import axios from "axios";

const filterData = async () => {
  const accessToken = localStorage.getItem("access_token");
  if (!accessToken) return Promise.reject("Unauthorized");

  try {
    const response = await axios.get("/data/filterData.json", {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching country data:", error);
    return Promise.reject(error);
  }
};

export default {
  filterData,
};
